<template>
  <div>
    <Header1></Header1>
    <div class="Index1">
      <div class="customerService">当前位置：<router-link to="/index">首页 </router-link> > 帮助中心</div>
      <div class="IndexMoode">
        <div class="header">
          <p style="margin: 0 auto;font-size: 30px;color: #0d85e1;width: 250px;padding-top: 15px;text-align: center">
            帮助中心
          </p>
          <div class="search">
            <!-- 获取用户搜索的关键词,返回搜索结果-->
            <input v-model="query.searchName"
                   placeholder="搜索内容"
                   class="contentSearchInput" />
            <button @click="getList"
                    class="searchButton">搜索</button>
          </div>
        </div>
        <div v-show="tab == 1">
          <div style="width: 1000px;height: 50px;line-height: 50px;margin:15px auto">
            <span style="font-size:20px; color: #848484;">常见问题 </span>
            <span @click="moreProblems"
                  style="cursor: pointer;font-size: 16px;color: #848484;margin: 0 2%;float: right">更多>></span>
          </div>
          <!-- 在getList()方法中通过msg = questionList,获得`答案`数组,v-for遍历出每一条数据对象即item -->
          <div class="problemBox"
               v-for="(item, index) in msg"
               v-if="index < 3">
            <img style="width: 23px;height: 23px"
                 src="../assets/Img/questionMark.png"
                 alt="" />
            <span>问题：{{ item.title }}</span>
            <!-- 查看答案, :visible.sync="dialogVisible"默认设置不显示 
						点击`查看答案`按钮,执行openModal(item)方法,item(item->msg->questionList)赋值给type,type.body(后台返回的`答案`数据)
						赋值给this.textModal,textModal为data中数据,渲染到:visible.sync="dialogVisible"标签中.
						方法中,"dialogVisible"是否可见值该为true可见
						-->
            <button class="viewAnswerButton"
                    @click="openModal(item)">查看答案</button>
          </div>

          <div style="width: 1000px;height: 50px;line-height: 50px;margin:15px auto">
            <span style="font-size:20px; color: #848484;">用户留言 </span>
            <span @click="moreMessage"
                  style="cursor: pointer;font-size: 16px;color: #848484;margin: 0 2%;float: right">更多>></span>
          </div>
          <div class="messageBox"
               style="border: 1px solid #d4d4d4;width: 84%;height: 100%;margin: 10px auto">
            <div v-for="(item,index) in messageBox"
                 v-if="index < 3"
                 style="width: 90% ;margin: 5px auto;border-bottom: 1px dashed #d4d4d4">
              <p style="cursor: pointer"
                 @click="questionShow(item)">
                <img src="../assets/Img/user.png"
                     style="width: 15px;height: 15px;margin-top: 5px">
                <span style="margin-left: 5px ;">{{item.username}}</span>
                <span class="userQuestion">{{item.question}}</span>
                <span style="float: right">{{item.questiontime}}</span>
              </p>
              <p style="color:#C8B55F;cursor: pointer"
                 @click="questionShow(item)">
                <img src="../assets/Img/administrator.png"
                     style="width: 15px;">
                <span style="margin-left: 5px;">{{item.adminname}}</span>
                <span class="userQuestion">{{item.answer}} </span>
                <span style="float: right">{{item.answertime}}</span>
              </p>
            </div>
          </div>
          <div style="width: 1000px;height: 50px;line-height: 50px;margin:15px auto">
            <span style="font-size:20px; color: #848484;"
                  @click="getOwnUserQuestions">我要留言 </span>
          </div>
          <div style="width: 85%;margin: 0 auto">
            <el-input type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      v-model="textarea"></el-input>
            <div @click="addUserQuestions"
                 class="submitBtn">提交</div>
          </div>

        </div>
        <div v-show="tab == 2">
          <span @click="backBtn"
                class="backBtn">返回</span>
          <div class="problemBox"
               v-for="(item, index) in msg">
            <img style="width: 23px;height: 23px"
                 src="../assets/Img/questionMark.png"
                 alt="" />
            <span>问题：{{ item.title }}</span>
            <button class="viewAnswerButton"
                    @click="openModal(item)">查看答案</button>
          </div>
          <!--<div v-show="isShow" style="margin:0 auto; width: 100px">暂无数据</div>-->
          <div style="margin: 0 auto; width: 400px">
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="page.number"
                           :page-sizes="[10, 20, 50]"
                           :page-size="page.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="page.totalElements">
            </el-pagination>
          </div>
        </div>
        <div v-show="tab == 3">
          <span @click="backBtn"
                class="backBtn">返回</span>
          <el-tabs v-model="activeName"
                   type="card"
                   style="width: 85%;margin: 20px auto">
            <el-tab-pane label="用户留言"
                         name='1'>
              <div class="messageBox"
                   style="width: 100%;height: 100%;margin: 0 auto">
                <div v-for="(item,index) in messageBox"
                     style="width: 98% ;margin: 5px auto;border-bottom: 1px dashed #d4d4d4">
                  <p style="cursor: pointer"
                     @click="questionShow(item)">
                    <img src="../assets/Img/user.png"
                         style="width: 15px;height: 15px">
                    <span style="margin-left: 5px">{{item.username}}</span>
                    <span class="userQuestion">{{item.question}}</span>

                    <span style="float: right">{{item.questiontime}}</span>
                  </p>
                  <p style="color:#C8B55F;cursor: pointer"
                     @click="questionShow(item)">
                    <img src="../assets/Img/administrator.png"
                         style="width: 15px">
                    <span style="margin-left: 5px">{{item.adminname}}</span>
                    <span class="userQuestion">{{item.answer}} </span>
                    <span style="float: right">{{item.answertime}}</span>
                  </p>
                </div>
              </div>
              <div style="margin: 30px auto; width: 400px">
                <el-pagination @size-change="handleSizeChange1"
                               @current-change="handleCurrentChange1"
                               :current-page="page1.number"
                               :page-sizes="[10, 20, 50]"
                               :page-size="page1.size"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="page1.totalElements">
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane label="我的留言"
                         @click="getOwnUserQuestions"
                         name='2'>
              <div class="content">
                <div class="messageBox"
                     style="width: 100%;height: 100%;margin: 0 auto">
                  <div v-for="(item,index) in userMessage"
                       style="width: 98% ;margin: 5px auto;border-bottom: 1px dashed #d4d4d4">
                    <p style="cursor: pointer"
                       @click="questionShow(item)">
                      <img src="../assets/Img/user.png"
                           style="width: 15px;height: 15px">
                      <span style="margin-left: 5px">{{item.username}}</span>
                      <span class="userQuestion">{{item.question}}</span>
                      <span style="float: right">{{item.questiontime}}</span>
                    </p>
                    <p style="color:#C8B55F;cursor: pointer"
                       @click="questionShow(item)">
                      <img src="../assets/Img/administrator.png"
                           style="width: 15px">
                      <span style="margin-left: 5px">{{item.adminname}}</span>
                      <span class="userQuestion">{{item.answer}} </span>
                      <span style="float: right">{{item.answertime}}</span>
                    </p>
                  </div>
                </div>
                <div style="margin: 30px auto; width: 400px">
                  <el-pagination @size-change="handleSizeChange2"
                                 @current-change="handleCurrentChange2"
                                 :current-page="page2.number"
                                 :page-sizes="[10, 20, 50]"
                                 :page-size="page2.size"
                                 layout="total, sizes, prev, pager, next, jumper"
                                 :total="page2.totalElements">
                  </el-pagination>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <el-dialog title="答案"
                   :visible.sync="dialogVisible"
                   width="58%">
          <!-- <span>{{ textModal }}</span> -->
          <!-- 使用v-html标签解析后台返回中的<p>标签 使`答案`查看显示分条-->
          <span v-html="textModal"
                class="fwbbox"></span>
          <span slot="footer"
                class="dialog-footer"></span>
        </el-dialog>

        <el-dialog title="详情"
                   :visible.sync="questionsShow"
                   width="40%">
          <span style="margin-bottom: 20px;text-indent: 2em;padding: 0 20px;line-height: 26px;">问题：{{question}}</span>
          <span style="margin-bottom: 20px;text-indent: 2em;padding: 0 20px;line-height: 26px;color: #C8B55F;">回复：{{answer}}</span>
          <span slot="footer"
                class="dialog-footer"></span>
        </el-dialog>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header1 from '../components/Header1.vue';
import Foot from '../components/Foot.vue';
import $ from 'jquery';
import { request } from '../API/ApiUrl';
import Pager from '../components/Pager';
import { Message } from 'element-ui'
export default {
  data () {
    return {
      questionsShow: false,
      activeName: "1",
      show: false,
      isShow: false,
      //输入的内容,事先约定好的
      inputValue: '',
      textModal: '',
      question: '',
      answer: '',
      //聊天的数组内容
      // messageList: [],
      msg: [],
      messageBox: [],
      userMessage: [],
      page: {
        size: 10,
        number: 1,
        content: [],
        totalElements: 0
      },
      page1: {
        size: 10,
        number: 1,
        content: [],
        totalElements: 0
      },
      page2: {
        size: 10,
        number: 1,
        content: [],
        totalElements: 0
      },
      dialogVisible: false,
      query: {
        searchName: '' //关键字名称
      },
      tab: 1,
      textarea: "",
      loginData: ''
    };
  },
  watch: {
    activeName (val) {
      if (val != 1) {
        this.getOwnUserQuestions();
      }
    }
  },
  components: {
    Foot,
    Header1,
    Pager
  },
  methods: {
    handleSizeChange (val) {
      //console.log(val)
      this.page.size = val
      this.getList();
    },
    handleCurrentChange (val) {
      //console.log(val)
      this.page.number = val

      this.getList();
    },
    handleSizeChange1 (val) {
      //console.log(val)
      this.page1.size = val
      this.getUserQuestions();
    },
    handleCurrentChange1 (val) {
      //console.log(val)
      this.page1.number = val

      this.getUserQuestions();
    },
    handleSizeChange2 (val) {
      //console.log(val)
      this.page2.size = val
      this.getOwnUserQuestions();
    },
    handleCurrentChange2 (val) {
      //console.log(val)
      this.page2.number = val

      this.getOwnUserQuestions();
    },
    backBtn () {
      this.tab = 1
    },
    //增加点击量
    addVisit () {
      request('/apiVisit/addVisitData', { "module": 101 }).then(res => {

      })
    },
    openModal (type) {
      this.dialogVisible = true;
      this.textModal = type.body;
    },
    questionShow (item) {
      this.questionsShow = true;
      this.question = item.question
      this.answer = item.answer
      this.getOwnUserQuestions();
    },
    //分页 问题展示
    getList () {
      if (!this.show) {
        request('/apiHelp/helpInit', {
          offset: this.page1.number,
          limit: this.page1.size,
          title: this.query.searchName, //搜索词
          type: 1
        }).then(res => {
          //返回对象,状态码200表示成功
          if (res.code === 200) {
            this.msg = res.data.questionList;
            //console.log("res.data.questionList")
            //console.log(res)
            //console.log(res.data)
            //console.log(res.data.questionList)
            //console.log(res.data.questionList[0].body)
            this.page.totalElements = res.data.count;
            if (res.data.count == 0) {
              this.isShow = true;
            } else {
              this.isShow = false;
            }
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            });
          }
        });
      }

    },

    moreProblems () {
      this.tab = 2;
      this.getOwnUserQuestions();
    },
    moreMessage () {
      if (this.loginData != '') {
        this.tab = 3
      } else {
        Message.warning('请先登录')
      }

    },
    //获取用户总留言
    getUserQuestions () {
      request('/apiHelp/getUserQuestions', {
        offset: this.page1.number,
        limit: this.page1.size,
        module: 1
      }).then(res => {
        if (res.code === 200) {
          this.page1.totalElements = res.data.count;
          this.messageBox = res.data.answerList
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      })
    },
    //增加用户留言
    addUserQuestions () {
      if (this.loginData != "") {
        request('/apiHelp/addUserQuestion',
          {            userid: this.loginData.userId, username: this.loginData.name, question: this.textarea,
            module: 1, passflag: -1          }).then(res => {
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
              this.textarea = ''
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          })

      } else {
        this.$message({
          message: '请先登录再留言',
          type: 'warning'
        });
      }
    },
    //获取用户个人留言
    getOwnUserQuestions () {
      request('/apiHelp/getOwnUserQuestions', {
        offset: this.page2.number,
        limit: this.page2.size,
        userid: this.loginData.userId,
        module: 1,
        passflag: -1
      }).then(res => {
        if (res.code === 200) {
          this.page2.totalElements = res.data.count;
          this.userMessage = res.data.answerList
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      })
    },
  },
  mounted () {
    //user
    if (sessionStorage.loginData) {
      this.loginData = JSON.parse(sessionStorage.loginData);
      //console.log(sessionStorage.loginData);
    }
    this.box = this.$refs.charView;
    // this.getList();
    //keywords
    if (this.$route.query.keywords) {
      this.query.searchName = this.$route.query.keywords;
    }
    //visit
    this.addVisit();
    this.getList();
    //user message
    this.getUserQuestions();
    if (this.loginData != '') {
      //console.log(11111)
      this.getOwnUserQuestions();
    }


  }
};
</script>

<style  scoped>
/deep/ .fwbbox > p {
  /* color: red; */
  text-indent: 3pt !important;
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: 微软雅黑;
}
.waperHelp {
  width: 780px;
  margin: 0 auto;
}
.distpicker-address-wrapper select {
  padding: 0;
  font-size: 14px;
  border-radius: 0;
  height: 30px;
  line-height: 30px;
}
#container {
  width: 100%;
  border-radius: 5px;
}

.DiFangZhiListTop {
  display: flex;
  justify-content: space-between;
  padding-top: 55px;
  width: 1200px;
  margin: 0 auto;
  align-items: center;
}
.Font_size {
  font-size: 16px;
}
.Index1 {
  width: 100%;
  margin: 0 auto;
  padding-bottom: 50px;
}
.customerService {
  padding: 30px 0;
  width: 250px;
  text-align: center;
  font-size: 16px;
  /*padding-bottom: 23px;*/
  margin-left: 13.5%;
}
.IndexMoode {
  width: 1200px;
  /*background: #e8edef42;*/
  margin: 0 auto;
  padding-bottom: 50px;
}
.IndexMoodeHeadder {
  padding: 30px 0 15px 0;
  font-size: 25px;
  text-align: center;
}
.LoginIndex {
  font-size: 13px;
  width: 250px;
  margin: 0 auto;
}
::-webkit-input-placeholder {
  font-size: 13px;
}
.LoginIndex > div {
  text-align: left;
}
.Input {
  margin: 5px 0 13px;
}
.InputYanZhen {
  width: 125px;
  height: 30px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(215, 215, 215, 1);
  box-sizing: border-box;
  padding-left: 8px;
}
.Yanzhen {
  display: flex;
  width: 250px;
  justify-content: space-between;
  margin: 5px 0 10px;
}
.Yanzhen > div {
  width: 100px;
  text-align: center;
  font-size: 13px;
  box-sizing: border-box;
  line-height: 30px;
  color: #fff;
  height: 30px;
  cursor: pointer;
}
.borderr {
  display: flex;
  width: 250px;
  margin: 0 auto;
  font-size: 13px;
}
.borderr > div:nth-child(1) inputs {
  width: 12px;
  height: 12px;
  background: #fff;
  border: none;
  margin-top: 3px;
  margin-right: 3px;
  cursor: pointer;
}
.checkboxRead {
  margin-right: 4px;
  margin-top: 1px;
}
.SpanColor {
  color: rgb(0, 122, 204);
}
.BTN {
  height: 40px;
  width: 250px;
  margin: 0 auto;
  background: #16c0a9;
  color: #fff;
  font-size: 15px;
  line-height: 40px;
  margin-top: 50px;
  text-align: center;
}
.yanzhengma {
  height: 30px;
  background: #ffffff;
}
.footer {
  width: 100%;
  height: 118px;
  overflow: hidden;
  border: 1px solid #e6e6e6;
  border-right: none;
  position: relative;
}
.footer input {
  width: 100%;
  height: 45px;
  /*outline: none;*/
  font-size: 20px;
  text-indent: 10px;
  /*position: absolute;*/
  border-radius: 6px;
  margin-left: 10px;
  line-height: 45px;
}
.footer #btn {
  width: 76px;
  height: 36px;
  border: none;
  background-color: #0962da;
  color: #ffffff;
  border-radius: 6px;
  position: absolute;
  right: 20px;
  bottom: 20px;
}
.footer #btn:hover {
  background: #67c23a;
  cursor: pointer;
}
.content1 {
  font-size: 20px;
  width: 100%;
  height: 420px;
  overflow: auto;
  background-color: #f3f9fd;
  border: 1px solid #e6e6e6;
}
.content1 li {
  margin-top: 10px;
  display: block;
  clear: both;
  overflow: hidden;
}
.content1 li span {
  background: #e4f2fa;
  padding: 10px;
  border-radius: 10px;
  float: left;
  margin: 6px 10px 0 10px;
  max-width: 310px;
  border: 1px solid #ccc;
  box-shadow: 0 0 3px #ccc;
  word-break: break-all;
  font-size: 12px;
}
.content1 li span.spanleft {
  float: left;
}
.content1 li span.spanright {
  float: right;
}
.header {
  width: 83%;
  height: 168px;
  background-image: url("../assets/Img/headBanner.jpg");
  background-size: 100% 168px;
  margin: 0 auto;
}
.search {
  width: 520px;
  margin: 0 auto;
  padding-top: 26px;
}
.contentSearchInput {
  width: 420px;
  height: 35px;
  border: 1px solid #e1e1e1;
  border-radius: 2px;
  padding-left: 20px;
}
.searchButton {
  width: 66px;
  height: 37px;
  background-color: #0962da;
  color: #ffffff;
  cursor: pointer;
  border: none;
}
.searchButton:hover {
  width: 66px;
  height: 37px;
  background-color: #0962da;
  color: #8eb7ed;
  cursor: pointer;
  border: none;
}
.problemBox {
  border: 1px solid #ededed;
  margin: 21px auto;
  width: 997px;
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  background-color: #fdfdfd;
  position: relative;
}
.problemBox:hover {
  border: 1px solid #ededed;
  margin: 21px auto;
  width: 997px;
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  background-color: #faf8f8;
  position: relative;
}
.problemBox img {
  padding-left: 30px;
  margin-top: 10px;
}
.problemBox span {
  padding-left: 10px;
  font-size: 18px;
}
.problemBox .viewAnswerButton {
  border: none;
  width: 80px;
  height: 26px;
  background-color: #0962da;
  color: #ffffff;
  position: absolute;
  right: 10px;
  top: 12px;
  border-radius: 4px;
  cursor: pointer;
}
.problemBox .viewAnswerButton:hover {
  cursor: pointer;
  color: #7ef8fd;
}
.helpCenter {
  width: 842px;
  height: 73px;
  background-image: url("../assets/Img/helpCenter.jpg");
  margin: 0 auto;
}
.dialog1 {
  width: 842px;
  height: 674px;
  border: 1px solid #e6e6e6;
  margin: 10px auto;
}
.messageBox p {
  font-size: 13px;
  height: 30px;
  line-height: 30px;
}
.messageBox span {
  display: inline-flex;
}
.submitBtn {
  margin: 10px 50%;
  font-size: 18px;
  width: 79px;
  height: 38px;
  border: none;
  background-color: rgba(55, 135, 236, 1);
  color: #ffffff;
  cursor: pointer;
  line-height: 38px;
  text-align: center;
  border-radius: 5px;
  float: right;
}
.submitBtn:hover {
  background-color: #70db55;
}
.backBtn {
  font-size: 16px;
  cursor: pointer;
  margin-left: 9%;
  margin-top: 30px;
}
.backBtn:hover {
  color: #70db55;
}
.userQuestion {
  margin-left: 20px;
  max-width: 40em;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
